/* @ngInject */

export default (
  $rootScope,
  $scope,
  $q,
  helperService,
  organizationService,
  lendersService,
  changesService,
  uiService,
  webpage
) => {
  $scope.Model = {
    availableLenders: [],
    isReady: false
  };

    /*
     * Initialize controller and start loading the required data
     * --------------------------------------------------------------------------------
     */
    webpage.pageTitle('Loading, please wait');
    if ($rootScope.CurrentAccount.isAdministrator) {
      $q.all([
        organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id }),
        lendersService.getAvailable({ cca2: [helperService.getOrganizationCountry().cca2] })
      ])
        .then((data) => {
          // Overwrite $rootScope values in case they've reverted to values within Token
          // eslint-disable-next-line no-param-reassign
          $rootScope.CurrentOrganization.enterprise.lenderCommissions =
            data[0].enterprise.lenderCommissions;
          // Set Model values
          let availableLenders = data[1];
          if ($rootScope.isNlg()) {
            availableLenders = _.filter(data[1], (l) => l?.type.indexOf('ASSET_FINANCE') > -1);
          }
          $scope.Model.availableLenders = availableLenders;
          // Process Model values
          $scope.Model.availableLenders.forEach((l) => {
            const lender = l;
            const commission = $rootScope.CurrentOrganization.enterprise.lenderCommissions.find(
              (c) => c.id === lender.id
            );
            lender.upfront =
              commission && parseInt(commission.upfront, 10) >= 0
                ? commission.upfront
                : undefined;
            lender.trail =
              commission && parseInt(commission.trail, 10) >= 0 ? commission.trail : undefined;
            lender.externalId = commission?.externalId || '';
            lender.externalName = commission?.externalName || '';
            lender.externalProductName = commission?.externalProductName || '';
            lender.externalProductId = commission?.externalProductId || '';
            lender.externalProductIdVbi = commission?.externalProductIdVbi || '';
            lender.externalProductIdRedbook = commission?.externalProductIdRedbook || '';
          });
        })
        .then(() => {
          // Declare Model as Ready and start rendering the page
          webpage.pageTitle('Lender commissions : Settings');
          $scope.Model.isReady = true;
        });
    }

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.toggleChanges = () => {
    changesService.change();
  };

  $scope.isRootOrg = () =>
    $rootScope.CurrentOrganization.id === 'dd5752f9-97d3-4bc8-89de-134fb750f8f6';

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  function saveChanges() {
    const organizationData = {
      id: $rootScope.CurrentOrganization.id,
      enterprise: {
        lenderCommissions: _.map($scope.Model.availableLenders, (l) => ({
          id: l.id,
          abbr: l.abbr,
          upfront: l.upfront,
          trail: l.trail,
          externalId: l.externalId,
          externalName: l.externalName,
          externalProductName: l.externalProductName,
          externalProductId: l.externalProductId,
          externalProductIdVbi: l.externalProductIdVbi,
          externalProductIdRedbook: l.externalProductIdRedbook
        }))
      }
    };
    return organizationService.updateOrganization(organizationData).then((result) => {
      if (result.status) {
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  }

  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);
};
